import { MembersListPage } from '@/components/members/members-list-page'

export function CommitteeMembers() {
  return (
    <MembersListPage
      basePath="/committee/members"
      description="View member accounts and update contact details."
    />
  )
}
